<template lang="pug">
button.search__tag(@click="removeTag(tag)") {{ tag.value }}
</template>


<script>
export default {
  name: "BlueTagItem",
  props: ["tag", "removeTag"],
};
</script>

<style lang="scss" scoped>
.search__tag {
  appearance: none;
  background: transparent;
  border: none;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  padding: 0.5rem 0.75rem;
  font-size: 0.75rem;
  background: var(--tag-background);
  color: var(--tag-color);
  cursor: pointer;
  transition: var(--tag-transition);

  &:hover {
    background: var(--tag-hover-background);
    color: var(--tag-hover-color);
  }

  &::after {
    content: "\d7";
  }
}
</style>